exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, ".fade-enter-active[data-v-594c5e30],.fade-leave-active[data-v-594c5e30]{transition:opacity .5s}.fade-enter[data-v-594c5e30],.fade-leave-to[data-v-594c5e30]{opacity:0}.error[data-v-594c5e30]{color:red}.mainCardBG[data-v-594c5e30]{background-color:#fff}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./~/css-loader!./~/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-594c5e30","scoped":true,"hasInlineConfig":false}!./~/vue-loader/lib/selector.js?type=styles&index=0!./src/component/airFreight/airCCTPTConsol.vue
// module id = 1626
// module chunks = 0